const InputError = (props) => {
    const { errMsg } = props;
    console.log("Error Message: ", errMsg)
    return(
        <>
            {
                errMsg ? (
                    <div className="errMsg">{errMsg}</div>
                ):(
                    <div></div>
                )
            }
        </>
    )
}

export default InputError;